<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'logsCrud'"
          crudName="Logs do Sistema"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableDownloadPdf="false"
          :enableDownloadExcel="false"
          :enableAdd="false"
          :enableEdit="false"
          :enableDelete="false"
          :enableActive="false"
          :enableView="true"
          :enableReset="false"
          :enableSenhaPath="false"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  components: {
    BaseCrud,
  },
  data: function () {
    return {
      table: "logsTable",
      columns: [
        "id",
        "user_id",
        "log_type_id",
        "description",
        "status",
        "created_at_f",
        "actions",
      ],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: [
          "id",
          "user_id",
          "log_type_id",
          "description",
          "status",
          "created_at_f",
        ],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 25,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "ID",
          user_id: "Usuário",
          log_type_id: "Tipo de Log",
          description: "Descrição",
          status: "Status",
          created_at_f: "Data/Hora",
          actions: "Ações",
        },
        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {
          status: [
            {
              id: 1,
              text: "Ativo",
            },
            {
              id: 0,
              text: "Inativo",
            },
          ],
        },
        sortable: ["id", "user_id", "log_type_id", "created_at_f"],
        listColumns: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [];

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
        templates: {},
      },
      endPoint: "logs",
      dataForm: {},
    };
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome: "nome",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&orderByDesc";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}
.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
